module.exports = __webpack_public_path__ + "media/images/home/cover-mobile@2x-145ee3792cde182fd70d28f2fce87669.jpg";